<template>
  <div
    class="sticky top-0 z-[9999]"
    :class="[mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100']"
  >
    <header
      class="border-b xl:hidden"
      :class="[
        mode === 'dark'
          ? 'border-dark-border bg-dark-sidebar'
          : 'border-border-100 bg-white-100',
      ]"
    >
      <div class="app-container">
        <div class="flex h-20 items-center justify-between">
          <RouterLink to="/" class="flex">
            <img
              src="/ITAD_Logo_sm.png"
              alt="ASDI NATD"
              loading="lazy"
              width
              height
              class="h-[60px] w-auto"
            />
          </RouterLink>
          <ul class="flex items-center justify-center gap-8 lg:gap-4">
            <li
              v-for="(link, index) in links"
              class="py-[28px]"
              :class="[link?.subs ? 'group relative' : '']"
              :key="index"
            >
              <a
                :href="link.link"
                target="_blank"
                class="inline-flex items-center gap-1 text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                >{{ link.name }}
                <ChevronDown
                  :size="17"
                  :stroke-width="2"
                  v-if="link?.subs"
                  class="mt-[1px] transform transition-transform duration-150 group-hover:rotate-180"
              /></a>
              <div
                v-if="link?.subs"
                class="absolute left-0 top-16 z-20 hidden min-w-[250px] rounded-lg border p-4 shadow-primary group-hover:block"
                :class="[
                  mode === 'dark'
                    ? 'border-dark-border bg-dark-sidebar'
                    : 'border-border-10 bg-white-100',
                ]"
              >
                <ul class="flex flex-col gap-3">
                  <li
                    v-for="(sub, key) in link.subs"
                    :key="key"
                    class="leading-none"
                  >
                    <a
                      :href="sub.link"
                      target="_blank"
                      class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                      >{{ sub.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <ul class="flex items-center gap-2">
            <li class="py-[28px]">
              <a
                href="https://www.linkedin.com/company/ascdi"
                target="_blank"
                class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#0077B5] hover:bg-[#0077B5] hover:text-white-100"
                :class="[
                  mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                ]"
              >
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666217 4.26017C0.221274 3.84145 0 3.32314 0 2.70644C0 2.08975 0.222458 1.54862 0.666217 1.12869C1.11116 0.709963 1.68391 0.5 2.38564 0.5C3.08737 0.5 3.63764 0.709963 4.0814 1.12869C4.52634 1.54742 4.74762 2.07415 4.74762 2.70644C4.74762 3.33874 4.52516 3.84145 4.0814 4.26017C3.63646 4.6789 3.07199 4.88887 2.38564 4.88887C1.69929 4.88887 1.11116 4.6789 0.666217 4.26017ZM4.37369 6.66217V19.5H0.372746V6.66217H4.37369Z"
                    fill="currentColor"
                  />
                  <path
                    d="M17.6924 7.9304C18.5645 8.89024 19 10.2076 19 11.885V19.2733H15.2003V12.4057C15.2003 11.5598 14.9837 10.9023 14.5518 10.4344C14.1198 9.96647 13.5376 9.7313 12.8087 9.7313C12.0797 9.7313 11.4975 9.96527 11.0656 10.4344C10.6337 10.9023 10.4171 11.5598 10.4171 12.4057V19.2733H6.59487V6.62624H10.4171V8.30355C10.8041 7.74445 11.3259 7.30292 11.9815 6.97777C12.6371 6.65263 13.3743 6.49065 14.1944 6.49065C15.6547 6.49065 16.8214 6.97056 17.6924 7.9304Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>
            <li class="py-[28px]">
              <a
                href="https://twitter.com/ASCDINATD"
                target="_blank"
                class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150"
                :class="[
                  mode === 'dark'
                    ? 'border-dark-border hover:!border-white-100 hover:bg-white-100 hover:text-[#000]'
                    : 'border-border-10 hover:!border-[#000] hover:bg-[#000] hover:text-white-100',
                ]"
              >
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="h-[19px] w-[19px]"
                >
                  <path
                    d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                  ></path>
                </svg>
              </a>
            </li>
            <li class="py-[28px]">
              <a
                href="https://www.facebook.com/pages/Ascdi-Natd/246285985410420"
                target="_blank"
                class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#4267B2] hover:bg-[#4267B2] hover:text-white-100"
                :class="[
                  mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                ]"
              >
                <svg
                  width="9"
                  height="18"
                  viewBox="0 0 9 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.0324 4.33062V6.72736H8.99923L8.52944 9.95592H6.0324V17.3944C5.53176 17.4638 5.01954 17.5 4.49961 17.5C3.89946 17.5 3.31011 17.4522 2.73618 17.3597V9.95592H0V6.72736H2.73618V3.79485C2.73618 1.97551 4.21188 0.5 6.03317 0.5V0.501543C6.03857 0.501543 6.0432 0.5 6.0486 0.5H9V3.29222H7.07148C6.49833 3.29222 6.03317 3.75707 6.03317 4.32985L6.0324 4.33062Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>
            <li v-if="loggedInUser" class="group relative ml-2 py-[28px]">
              <div class="cursor-pointer">
                <div v-if="contact.email" class="relative">
                  <img
                    :src="gravatar"
                    :alt="contact.first_name + ' ' + contact.last_name"
                    class="h-8 w-8 rounded-full"
                  />
                  <span
                    class="absolute -bottom-[1px] -right-[1px] h-3 w-3 rounded-full border-2 bg-primary-100"
                    :class="[
                      mode === 'dark'
                        ? 'border-dark-sidebar'
                        : 'border-white-100',
                    ]"
                  ></span>
                </div>
                <Settings v-else :size="22" :stroke-width="1.75" />
              </div>
              <div
                class="absolute right-0 top-16 z-20 hidden min-w-[250px] rounded-lg border p-4 shadow-primary group-hover:block"
                :class="[
                  mode === 'dark'
                    ? 'border-dark-border bg-dark-sidebar'
                    : 'border-border-10 bg-white-100',
                ]"
              >
                <ul class="flex flex-col gap-3">
                  <li class="leading-none">
                    <RouterLink
                      :to="{
                        name: 'edit-contact',
                        params: { id: contact.contact_id },
                      }"
                      @click="redirect()"
                      class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                      >Your Profile</RouterLink
                    >
                  </li>
                  <li class="leading-none">
                    <RouterLink
                      :to="{
                        name: 'settings',
                      }"
                      @click.prevent="redirect('settings')"
                      class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                      >Company Profile</RouterLink
                    >
                  </li>
                  <li class="leading-none">
                    <span
                      @click.prevent="handleSingOut"
                      class="cursor-pointer text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                      >Logout</span
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <header class="hidden xl:block">
      <div
        class="flex h-[70px] items-center justify-between border-b px-4"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <RouterLink to="/" class="flex">
          <img
            src="/ITAD_Logo_sm.png"
            alt="ASDI NATD"
            loading="lazy"
            width
            height
            class="h-[60px] w-auto"
          />
        </RouterLink>
        <div class="flex items-center gap-4">
          <span @click="isMenu = true" class="cursor-pointer">
            <Menu :size="22" :stroke-width="1.75" />
          </span>
          <div v-if="loggedInUser" class="group relative py-[19px]">
            <div class="cursor-pointer">
              <div v-if="contact.email" class="relative">
                <img
                  :src="gravatar"
                  :alt="contact.first_name + ' ' + contact.last_name"
                  class="h-8 w-8 rounded-full"
                />
                <span
                  class="absolute -bottom-[1px] -right-[1px] h-3 w-3 rounded-full border-2 bg-primary-100"
                  :class="[
                    mode === 'dark'
                      ? 'border-dark-sidebar'
                      : 'border-white-100',
                  ]"
                ></span>
              </div>
              <Settings v-else :size="22" :stroke-width="1.75" />
            </div>
            <div
              class="absolute right-0 top-14 z-20 hidden min-w-[250px] rounded-lg border p-4 shadow-primary group-hover:block"
              :class="[
                mode === 'dark'
                  ? 'border-dark-border bg-dark-sidebar'
                  : 'border-border-10 bg-white-100',
              ]"
            >
              <ul class="flex flex-col gap-3">
                <li class="leading-none">
                  <RouterLink
                    :to="{
                      name: 'edit-contact',
                      params: { id: contact.contact_id },
                    }"
                    @click="redirect()"
                    class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                    >Your Profile</RouterLink
                  >
                </li>
                <li class="leading-none">
                  <RouterLink
                    :to="{
                      name: 'settings',
                    }"
                    @click.prevent="redirect('settings')"
                    class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                    >Company Profile</RouterLink
                  >
                </li>
                <li class="leading-none">
                  <span
                    @click.prevent="handleSingOut"
                    class="cursor-pointer text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                    >Logout</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
    <header
      class="fixed -left-full top-0 z-20 min-h-screen w-[390px] transition-all duration-300 xs:w-full"
      :class="[
        isMenu ? 'xl:left-0' : 'xl:-left-full',
        mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100',
      ]"
    >
      <div
        class="flex h-[70px] items-center justify-between border-b px-4"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <RouterLink to="/" class="flex">
          <img
            src="/ITAD_Logo_sm.png"
            alt="ASDI NATD"
            loading="lazy"
            width
            height
            class="h-[60px] w-auto"
          />
        </RouterLink>
        <span @click="isMenu = false" class="cursor-pointer">
          <Menu :size="22" :stroke-width="1.75" />
        </span>
      </div>
      <div class="without-scrollbar h-menu overflow-auto px-4">
        <div class="py-4">
          <h4 class="mb-3 text-base font-semibold">Main navigation</h4>
          <ul class="grid gap-3">
            <li
              v-for="(link, index) in links"
              class="rounded-lg leading-none"
              :key="index"
              :class="[
                link?.subs && activeSubMenu === index
                  ? 'bg-primary-10 p-3'
                  : '',
              ]"
            >
              <a
                :href="link.link"
                target="_blank"
                @click.prevent="setActiveSubMenu(index)"
                class="flex items-center justify-between text-sm font-medium"
                :class="[
                  link?.subs && activeSubMenu === index ? 'font-semibold' : '',
                ]"
                >{{ link.name }}
                <ChevronDown
                  :size="20"
                  :stroke-width="2"
                  v-if="link?.subs"
                  class="transform transition-transform duration-150"
                  :class="[activeSubMenu === index ? 'rotate-180' : '']"
              /></a>
              <div v-if="link?.subs && activeSubMenu === index">
                <ul
                  class="flex flex-col gap-2"
                  :class="[activeSubMenu === index ? 'mt-3' : '']"
                >
                  <li
                    v-for="(sub, key) in link.subs"
                    :key="key"
                    class="leading-none"
                  >
                    <a
                      :href="sub.link"
                      target="_blank"
                      class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                      >{{ sub.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-if="loggedInUser"
          class="border-t py-4"
          :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
        >
          <h4 class="mb-3 text-base font-semibold">Member tools</h4>
          <div class="grid gap-4">
            <template v-for="(tool, index) in tools" :key="index">
              <template v-if="tool.link">
                <div v-if="tool.show">
                  <RouterLink
                    :to="{
                      name: tool.link,
                    }"
                    @click.prevent="redirect(tool.link)"
                    class="text-sm font-medium"
                    :class="[currentRoute === tool.link ? 'font-semibold' : '']"
                  >
                    <span class="flex items-center gap-2">
                      <Search
                        v-if="tool.icon === 'search'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Wrench
                        v-if="tool.icon === 'wrench'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <span class="mt-[2px]">{{ tool.name }}</span>
                    </span>
                  </RouterLink>
                </div>
              </template>
              <template v-else>
                <div
                  v-if="tool.show"
                  class="rounded-lg leading-none"
                  :class="[
                    activeToolMenus === index ? 'bg-primary-10 p-3' : '',
                  ]"
                >
                  <span
                    @click="setActiveToolMenus(index)"
                    class="flex cursor-pointer items-center justify-between text-sm font-medium"
                    :class="[activeToolMenus === index ? 'font-semibold' : '']"
                  >
                    <span class="flex items-center gap-2">
                      <ShieldUser
                        v-if="tool.icon === 'admin'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Waypoints
                        v-if="tool.icon === 'waypoints'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Settings
                        v-if="tool.icon === 'contacts'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Laptop
                        v-if="tool.icon === 'technical'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Lightbulb
                        v-if="tool.icon === 'tips'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Hammer
                        v-if="tool.icon === 'ethics'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <Grip
                        v-if="tool.icon === 'other'"
                        :size="24"
                        :stroke-width="1.75"
                      />
                      <span class="mt-[2px]">{{ tool.name }}</span>
                    </span>
                    <ChevronDown
                      :size="20"
                      :stroke-width="2"
                      class="transform transition-transform duration-150"
                      :class="[activeToolMenus === index ? 'rotate-180' : '']"
                  /></span>
                  <div v-if="activeToolMenus === index">
                    <ul
                      class="flex flex-col gap-2"
                      :class="[activeToolMenus === index ? 'mt-3' : '']"
                    >
                      <li
                        v-for="(sub, key) in tool.subs"
                        :key="key"
                        class="leading-none"
                      >
                        <RouterLink
                          v-if="sub?.params"
                          :to="{
                            name: sub.link,
                            params: { id: contact.contact_id },
                          }"
                          @click="redirect()"
                          class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                          :class="[
                            currentRoute === sub.link ? 'text-primary-100' : '',
                          ]"
                          >{{ sub.name }}</RouterLink
                        >
                        <RouterLink
                          v-else
                          :to="{
                            name: sub.link,
                          }"
                          @click.prevent="redirect(sub.link)"
                          class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                          :class="[
                            currentRoute === sub.link ? 'text-primary-100' : '',
                          ]"
                          >{{ sub.name }}</RouterLink
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div v-if="loggedInUser" class="py-4">
          <span
            @click.prevent="handleSingOut"
            class="flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded border"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <LogOut
              :size="20"
              :stroke-width="1.75"
              class="rotate-180 transform"
            />
          </span>
        </div>
      </div>
    </header>
    <div
      v-if="isMenu"
      @click="isMenu = false"
      class="fixed inset-0 z-10 hidden cursor-pointer bg-opacity-50 xl:block"
      :class="[mode === 'dark' ? 'bg-[#FFF]' : 'bg-[#000]']"
    ></div>
    <div
      @click="$emit('toggle')"
      :class="[
        mode === 'dark'
          ? 'border-dark-border bg-dark-sidebar'
          : 'border-border-10 bg-white-100',
      ]"
      class="fixed left-0 top-[120px] z-10 flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-br-md rounded-tr-md border border-l-0"
    >
      <Sun v-if="mode === 'dark'" :size="22" :stroke-width="1.75" />
      <Moon v-else :size="22" :stroke-width="1.75" />
    </div>
  </div>
</template>

<script>
import {
  ChevronDown,
  Grip,
  Hammer,
  Laptop,
  Lightbulb,
  LogOut,
  Menu,
  Moon,
  Search,
  ShieldUser,
  Sun,
  Settings,
  Wrench,
  X,
  Waypoints,
} from "lucide-vue-next";
import tools from "@L/data/tools";
import { useUserStore } from "@S/user";
import { useAuth } from "@CO/useAuth";
import md5 from "blueimp-md5";

export default {
  name: "Header",
  props: {
    mode: String,
  },
  components: {
    X,
    ChevronDown,
    Search,
    Settings,
    Laptop,
    Lightbulb,
    Hammer,
    Grip,
    LogOut,
    Menu,
    ShieldUser,
    Sun,
    Moon,
    Wrench,
    Waypoints,
  },
  setup() {
    const userStore = useUserStore();
    const { signOut } = useAuth();
    return {
      userStore,
      signOut,
    };
  },
  data() {
    return {
      links: [
        {
          name: "About",
          link: "http://www.ascdi.com/about-ascdinatd/",
          subs: [
            {
              name: "Board Members & Staff",
              link: "http://www.ascdi.com/about-ascdinatd/board-members-staff/",
            },
          ],
        },
        {
          name: "Member Benefits",
          link: "http://www.ascdi.com/member-benefits/",
          subs: [
            {
              name: "Industry Guidance",
              link: "http://www.ascdi.com/member-benefits/industry-guidance/",
            },
            {
              name: "Meetings - Education/Networking",
              link: "http://www.ascdi.com/member-benefits/meetings-educationnetworking/",
            },
            {
              name: "Legislation",
              link: "http://www.ascdi.com/member-benefits/legislation/",
            },
            {
              name: "Committees",
              link: "http://www.ascdi.com/member-benefits/committees/",
            },
          ],
        },
        {
          name: "PRESS",
          link: "http://www.ascdi.com/leadership/",
          subs: [
            { name: "Blog", link: "http://www.ascdi.com/ascdiblog/" },
            { name: "Press", link: "http://www.ascdi.com/press/" },
            { name: "Video", link: "http://www.ascdi.com/leadership/videos/" },
          ],
        },
        {
          name: "Meetings",
          link: "http://www.ascdi.com/events/",
        },
        {
          name: "Directory",
          link: "http://www.ascdi.com/directory/",
        },
      ],
      tools: [],
      activeSubMenu: null,
      activeToolMenus: null,
      isMenu: false,
    };
  },
  mounted() {
    this.currentRoute = this.$route.name;
    if (this.isAdmin) {
      this.tools = tools;
    } else {
      const updatedTools = tools.map((tool) => {
        if (tool.name === "Admin") {
          return { ...tool, show: false };
        }
        return { ...tool };
      });
      this.tools = updatedTools;
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    isAdmin() {
      return this.loggedInUser?.global_admin;
    },
    loggedInUser() {
      return this.userStore.user;
    },
    contact() {
      return this.loggedInUser.contact;
    },
    gravatar() {
      if (!this.contact.email) {
        return;
      }
      const hash = md5(this.contact.email.toLowerCase());
      return `https://www.gravatar.com/avatar/${hash}`;
    },
  },
  methods: {
    setActiveSubMenu(index) {
      this.activeSubMenu = this.activeSubMenu === index ? null : index;
    },
    setActiveToolMenus(index) {
      this.activeToolMenus = this.activeToolMenus === index ? null : index;
    },
    handleSingOut() {
      this.signOut();
    },
    redirect(link = false) {
      this.isMenu = false;
      if (!link) {
        return;
      }
      this.$router.replace({ path: "/" }).then(() => {
        this.$router.push({
          name: link,
        });
      });
    },
  },
  watch: {
    currentRoute() {
      this.setActiveToolMenus(
        this.tools.findIndex((tool) =>
          tool.subs.some((sub) => sub?.link === this.currentRoute),
        ),
      );
    },
  },
};
</script>
